move();
remove();
//remove2();

function move() {
  const threshold = window.innerHeight * 0.5 / window.innerHeight; // 10vhの場合

  const options = {
    root: null,
    rootMargin: '0px 0px 0px 0px',  // 必要に応じて調整
    threshold: threshold // 動的に設定されたthreshold
  };

//コールバック関数
function callback(entries, observer) {
entries.forEach(entry => {
  if(entry.isIntersecting) {
    entry.target.classList.add("active");
  }

})
}

//ターゲット要素をDOMで取得
const targets = document.querySelectorAll('.move');

//インスタンス化
const obs = new IntersectionObserver(callback, options);

//ターゲット要素の監視を開始
targets.forEach(target => {
    obs.observe(target);
});
}



function remove() {
  const threshold = window.innerHeight * 0.5 / window.innerHeight; // 10vhの場合

  const options = {
    root: null,
    rootMargin: '0px 0px 0px 0px',  // 必要に応じて調整
    threshold: threshold // 動的に設定されたthreshold
  };

//コールバック関数
function callback(entries, observer) {
entries.forEach(entry => {
  if(entry.isIntersecting) {
    entry.target.classList.add("active");
  } else {
    entry.target.classList.remove("active");
  }
})
}

//ターゲット要素をDOMで取得
const targets = document.querySelectorAll('.remove');

//インスタンス化
const obs = new IntersectionObserver(callback, options);

//ターゲット要素の監視を開始
targets.forEach(target => {
    obs.observe(target);
});
}

